import React from 'react';
import { connect } from 'react-redux';
import { selectors as apiSelectors } from 'zender-api-client';
import * as appSelectors from '../../../../selectors';

import UgcSelection from './UgcSelection.component';

const mapStateToProps = state => ({
	challengeId: appSelectors.router.challengeIdSelector(state),
	challenges: apiSelectors.ugc.challengesSelector(state),
	pathName: appSelectors.router.pathNameSelector(state),
	location: appSelectors.router.locationSelector(state),
});

export default connect(
	mapStateToProps
)(UgcSelection);



// WEBPACK FOOTER //
// ./src/ui/interaction/children/ugcvisualization/UgcSelection.container.js